import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Copy, Star } from 'lucide-react';


import template1 from '@/assets/hero-property.jpg';
import template2 from '@/assets/hero-property.jpg';
import template3 from '@/assets/hero-property.jpg';
import template4 from '@/assets/hero-property.jpg';
import template5 from '@/assets/hero-property.jpg';
import template6 from '@/assets/hero-property.jpg';
import template7 from '@/assets/hero-property.jpg';
import template8 from '@/assets/hero-property.jpg';

const TemplatePreview = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const templates = [
    {
      id: 1,
      name: 'Template 1',
      image: template1,
      rating: 4.8,
      uses: 1247,
      tag: 'Just Listed',
      tagColor: 'bg-red-500'
    },
    {
      id: 2,
      name: 'Template 2',
      image: template2,
      rating: 4.9,
      uses: 982,
      tag: 'Priced to Sell',
      tagColor: 'bg-blue-500'
    },
    {
      id: 3,
      name: 'Template 3',
      image: template3,
      rating: 4.7,
      uses: 756,
      tag: 'Open House',
      tagColor: 'bg-green-500'
    },
    {
      id: 4,
      name: 'Template 4',
      image: template4,
      rating: 4.6,
      uses: 634,
      tag: 'Seller Motivated',
      tagColor: 'bg-orange-500'
    },
    {
      id: 5,
      name: 'Template 5',
      image: template5,
      rating: 4.8,
      uses: 523,
      tag: 'Just Listed',
      tagColor: 'bg-purple-500'
    },
    {
      id: 6,
      name: 'Template 6',
      image: template6,
      rating: 4.9,
      uses: 445,
      tag: 'Priced to Sell',
      tagColor: 'bg-teal-500'
    },
    {
      id: 7,
      name: 'Template 7',
      image: template7,
      rating: 4.7,
      uses: 378,
      tag: 'Open House',
      tagColor: 'bg-yellow-500'
    },
    {
      id: 8,
      name: 'Template 8',
      image: template8,
      rating: 4.8,
      uses: 298,
      tag: 'Seller Motivated',
      tagColor: 'bg-red-700'
    }
  ];

  const template = templates.find(t => t.id === parseInt(id || '1'));

  if (!template) {
    navigate('/templates');
    return null;
  }

  const handleUseTemplate = () => {
    navigate(`/template-builder?template=${template.id}`);
  };

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />
      
      <main className="flex-1 p-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center gap-4 mb-6">
              <Button variant="ghost" onClick={() => navigate('/templates')}>
                <ArrowLeft className="mr-2 h-4 w-4" />
                Back to Gallery
              </Button>
              
              <div className="flex-1">
                <h1 className="text-3xl font-bold text-primary">{template.name}</h1>
                <div className="flex items-center gap-4 mt-2">
                  <div className="flex items-center">
                    <Star className="h-4 w-4 fill-current text-yellow-400 mr-1" />
                    <span className="text-sm text-muted-foreground">{template.rating}</span>
                  </div>
                  <span className="text-sm text-muted-foreground">
                    {template.uses.toLocaleString()} uses
                  </span>
                  <Badge className={`${template.tagColor} text-white`}>
                    {template.tag}
                  </Badge>
                </div>
              </div>
              
              <Button variant="cta" size="lg" onClick={handleUseTemplate}>
                <Copy className="mr-2 h-4 w-4" />
                Use This Template
              </Button>
            </div>
          </div>

          {/* Template Preview */}
          <Card className="shadow-elevated">
            <CardContent className="p-8">
              <div className="bg-white rounded-lg overflow-hidden shadow-soft">
                <img
                  src={template.image}
                  alt={template.name}
                  className="w-full h-auto object-cover"
                />
              </div>
              
              <div className="mt-6 text-center">
                <p className="text-muted-foreground mb-4">
                  This template includes editable sections for property images, headlines, pricing, 
                  address, description, and photo galleries. Perfect for real estate email Launches.
                </p>
                <Button variant="cta" size="lg" onClick={handleUseTemplate}>
                  <Copy className="mr-2 h-4 w-4" />
                  Start Editing This Template
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Template Features */}
          <div className="mt-8 grid md:grid-cols-3 gap-6">
            <Card>
              <CardContent className="p-6">
                <h3 className="font-semibold text-primary mb-2">Fully Editable</h3>
                <p className="text-sm text-muted-foreground">
                  Customize all text, images, colors, and layout elements to match your brand.
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6">
                <h3 className="font-semibold text-primary mb-2">Mobile Optimized</h3>
                <p className="text-sm text-muted-foreground">
                  Automatically responsive design that looks great on all devices.
                </p>
              </CardContent>
            </Card>
            
            <Card>
              <CardContent className="p-6">
                <h3 className="font-semibold text-primary mb-2">MLS Integration</h3>
                <p className="text-sm text-muted-foreground">
                  Import property data directly from your MLS to populate template fields.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TemplatePreview;